import { IMaterial } from "../types/data.interface";

export const formatMaterialIntoOption = (item: IMaterial) => ({
    value: item,
    label: `${item.four_digit_code} - ${item.name}`,
});

// Compositions carry the Material primary key (res_raw_material_id) as material_id, which is what
// PIS_REQUEST_COMPONENTS and PRODUCT_MOLD store; the four digit code only travels inside the description
export const toComponentMaterial = (material?: IMaterial | null) => ({
    material_id: material?.id ?? null,
    material_description: material
        ? material.four_digit_code
            ? `${material.four_digit_code} - ${material.name}`
            : material.name
        : null,
});

export const getMaterials = (
    materials: IMaterial[],
) =>
    materials.map(formatMaterialIntoOption);